export default __webpack_public_path__ + "static/media/Relic of the Ancient Sands.0be6877b.jpg";